export default __webpack_public_path__ + "static/consul-docker-extension-demo-95510d73e31b3e815d4b79488d46ce15.webp";